import $ from 'jquery';
require('bootstrap');
require('bootstrap-confirmation2');

// Any element with data-delete-url set will hide the row it's in
// and send the delete request to the server via ajax
window.deleteSetup = function deleteSetup() {
    $('[data-delete-url]').each(function () {
        var $target = $(this);
        if (!$target.hasClass('popConfirmSet')) {
            if (!$target[0].hasAttribute('data-placement')) {
                $target.attr('data-placement', 'left');
            }
            if (!$target[0].hasAttribute('data-btn-ok-label')) {
                $target.attr('data-btn-ok-label', 'Yes');
            }
            if (!$target[0].hasAttribute('data-btn-ok-class')) {
                $target.attr('data-btn-ok-class', 'btn btn-sm btn-danger');
            }
            if (!$target[0].hasAttribute('data-btn-cancel-label')) {
                $target.attr('data-btn-cancel-label', 'Cancel');
            }
            if (!$target[0].hasAttribute('data-btn-cancel-class')) {
                $target.attr('data-btn-cancel-class', 'btn btn-sm btn-outline-secondary');
            }
            if ($target[0].hasAttribute('data-confirm-content')) {
                $target.attr('data-content', $target.attr('data-confirm-content'));
            }

            $target.attr('data-toggle', 'confirmation');

            $target.confirmation({
                rootSelector: '[data-delete-url]',
                singleton: true,
                popout: true,
                title: 'Remove this item?',
                btnOkIconClass: '',
                btnCancelIconClass: '',
                onConfirm: function () {
                    var url = $target.attr('data-delete-url');
                    var data = {
                        '_token': $('input[name="_token"]').val()
                    };

                    // Check for custom data delete element
                    var element = $target.attr('data-delete-element');
                    var $tr = "";
                    if (typeof element != 'undefined') {
                        $tr = $target.closest(element);
                    } else {
                        // default element to remove is tr
                        $tr = $target.closest('tr');
                    }

                    // show that the pending action has kicked off by removing the row
                    $tr.slideUp();

                    $.ajax({
                        type: "DELETE",
                        url: url,
                        data: data,
                        error: function (data) {
                            // there was an error - restore the row
                            $tr.slideDown();
                            displayErrorGritter(data.responseJSON);
                        },
                        success: function (data) {
                            // The data has been deleted on the server
                            $tr.remove();
                        }
                    });
                }
            }).on('click', function(e) {
                e.preventDefault();
                var redirect = e.target.getAttribute('data-redirect-url');
                if (redirect) {
                    window.location.href = redirect;
                }
            });

        }
    });
}

// Used for any removable blocks.
window.multiFormDeleteSetup = function multiFormDeleteSetup() {
    $('.delete-action-block').each(function () {
        var $target = $(this);
        if (!$target.hasClass('popConfirmSet')) {
            $target.on('click', function () {
                $target.closest('.removable-block').slideUp("normal", function () {
                    $target.remove();
                });
            }).confirmation({
                title: 'Delete this block?',
                placement: 'left',
                btnOkLabel: 'Delete',
                btnOkClass: 'btn btn-sm btn-danger',
                btnOkIconClass: '',
                btnCancelLabel: 'Cancel',
                btnCancelClass: 'btn btn-sm btn-outline-secondary',
                btnCancelIconClass: '',
            }).addClass('popConfirmSet');
        }
    });
}
